import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { t } from '../../../services/i18nService';
import utilService from '../../../services/UtilService';
import navigationService from '../../../services/NavigationService';
import styles from './annotationItem.scss';
import DeleteButtons from './DeleteButtons';
import annotationService from '../../../services/AnnotationService';
import NoteInput from './NoteInput';
import scorableItemNumberingService from '../../../services/questionView/ScorableItemNumberingService';
import UIConstants from '../../../constants/UIConstants';
import objectTypes from '../../../constants/ObjectTypes';

const AnnotationItem = ({ content, contentId, focused, number, scorableItem, sectionId, selector, type, comment = '' }) => {
    const itemRef = useRef();
    const isLongContent = content.length >= UIConstants.TRUNCATED_ANNOTATION_LENGTH;
    const [contentIsOpened, setContentIsOpened] = useState(!isLongContent);
    const [annotationItemFocus, setAnnotationItemFocus] = useState();

    const toggleContentVisibility = (event) => {
        setContentIsOpened(!contentIsOpened);
        event.stopPropagation();
    };

    const onAnnotationItemClick = () => {
        if (!focused) {
            annotationService.dispatchFocusAnnotationEvent(selector);
            annotationService.setFocusedAnnotation(selector);
        }

        if (scorableItemNumberingService.useNumberPerInteraction() && !isNaN(scorableItem)) {
            navigationService.navigateToScorableItem(sectionId, contentId, scorableItem, true);
        } else if (type === objectTypes.CATEGORY.STIMULUS) {
            navigationService.navigateToSection(sectionId);
        } else {
            navigationService.navigateToQuestion(contentId, sectionId, true);
        }
    };

    const getQuestionNumber = () => {
        return (number && number.length > 0)
            ? <span className={styles.questionNumber}>{number}</span>
            : null;
    };

    let className = styles.annotationItem;

    useEffect(() => {
        if (focused) {
            itemRef.current.scrollIntoView();
        }
    }, []);

    const onAnnotationItemFocus = () => {
        if (!annotationItemFocus) {
            setAnnotationItemFocus(true);
        }
    };

    const onAnnotationItemBlur = () => {
        if (annotationItemFocus) {
            setAnnotationItemFocus(false);
        }
    };

    if (annotationItemFocus || focused) {
        className += ` ${styles.annotationItemFocused}`;
    }

    return (
        /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
        <li
            className={className}
            ref={itemRef}
            onFocus={onAnnotationItemFocus}
            onBlur={onAnnotationItemBlur}
        >
            <button className={styles.annotationTextButton} onClick={onAnnotationItemClick} >
                {getQuestionNumber()}
                <span className={styles.annotationText}>
                    {contentIsOpened
                        ? content
                        : utilService.truncate(content, UIConstants.TRUNCATED_ANNOTATION_LENGTH)
                    }
                </span>
            </button>
            {isLongContent
                ? <button className={styles.linkTypeButton} onClick={toggleContentVisibility}>
                    {contentIsOpened
                        ? t('button.showLess')
                        : t('button.showMore')
                    }
                </button>
                : null
            }

            <NoteInput
                questionId={contentId}
                selector={selector}
                focused={focused}
                comment={comment}
            />
            <DeleteButtons questionNumber={number} questionId={contentId} selector={selector} />
        </li>
    );
};

AnnotationItem.propTypes = {
    comment: PropTypes.string,
    content: PropTypes.string.isRequired,
    contentId: PropTypes.number.isRequired,
    focused: PropTypes.bool.isRequired,
    number: PropTypes.string,
    scorableItem: PropTypes.number,
    sectionId: PropTypes.number.isRequired,
    selector: PropTypes.array.isRequired,
    type: PropTypes.string,
};

export default AnnotationItem;
